import { render, staticRenderFns } from "./InsurerDashboard.vue?vue&type=template&id=664d3e61&scoped=true"
import script from "./InsurerDashboard.vue?vue&type=script&lang=js"
export * from "./InsurerDashboard.vue?vue&type=script&lang=js"
import style0 from "./InsurerDashboard.vue?vue&type=style&index=0&id=664d3e61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664d3e61",
  null
  
)

export default component.exports